import type * as React from 'react';
import { cn } from '../../../common/functions/cn';

type InputProps = Omit<React.ComponentProps<'input'>, 'size'> & { size?: 'sm' | 'default' };

export const Input = ({ className, type, size = 'default', ...props }: InputProps) => {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        size === 'sm' ? 'h-8 px-2 md:h-7' : 'h-9 px-2.5 md:h-8',
        'w-full min-w-0 rounded-md border border-input bg-transparent py-1.5 md:py-1',
        'text-base outline-hidden placeholder:text-muted-foreground md:text-sm',
        'file:inline-flex file:h-8 file:border-0 file:bg-transparent file:font-medium file:text-foreground file:text-sm',
        'focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50',
        'aria-invalid:border-error aria-invalid:ring-2 aria-invalid:ring-error/20',
        'aria-invalid:focus-visible:border-error aria-invalid:focus-visible:ring-error/60',
        'disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-muted disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
};
